module.exports = __webpack_public_path__ + "static/media/body_mass.b397a54a.svg";